import { render } from "./LogoUndip.vue?vue&type=template&id=71369e55"
const script = {}

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__